import * as React from "react";
import { useTranslation } from "react-i18next";
import i18n from "i18n";
import Select from "components/common/Select";
import { useSystemLocales } from "hooks/useSystemStore";
import Spinner from "components/common/Spinner";
const _formatLocales = (locales) => {
  const sortedLocales = Object.values(locales).filter((locale) => locale.language_tag !== "und").map((locale) => ({ value: locale.language_tag, label: locale.display_name })).sort((a, b) => {
    const nameA = a.label.toUpperCase();
    const nameB = b.label.toUpperCase();
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    return 0;
  });
  return [{ value: "und", label: i18n.t("time.default_locale", { ns: "common" }) }].concat(sortedLocales);
};
const _renderOption = (option) => /* @__PURE__ */ React.createElement("span", { key: option.value, title: option.value }, option.label, " [", option.value, "]");
const LocaleSelect = (props) => {
  const { t } = useTranslation("common");
  const locales = useSystemLocales();
  if (!locales.data) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  const _locales = _formatLocales(locales.data);
  return /* @__PURE__ */ React.createElement(Select, { ...props, placeholder: t("time.pick_locale"), options: _locales, optionRenderer: _renderOption });
};
export default LocaleSelect;
